if (!customElements.get('mobile-audience-tabs')) {
  customElements.define(
    'mobile-audience-tabs',
    class MobileAudienceTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (nextIndex === null) return;

        event.preventDefault();
        this.select(nextIndex);
        this.tabs[nextIndex].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const isSelected = i === index;
          tab.classList.toggle('mobile-audience-tabs__tab--active', isSelected);
          tab.setAttribute('aria-selected', isSelected);
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }
    }
  );
}
